module.exports = __webpack_public_path__ + "img/pen-tool-02.2bccf7a3.svg";